import { useEffect } from 'react';

/**
 * Logs screen view analytics when the screen name changes
 */
export function useScreenViewLogging(
	analyticsName: string | undefined,
	logScreenView: (name: string) => void,
) {
	useEffect(() => {
		if (analyticsName) {
			logScreenView(analyticsName);
		}
	}, [analyticsName, logScreenView]);
}
